// Debt Control
export const DEBT_WARNING = 75000;
export const DEBT_TOO_LARGE = 100000;
